import { ButtonMain } from '@/modules/common/components/button';
import { numberToReadable } from '@/modules/common/helpers/number-to-readable.helper';
import { useStore } from 'effector-react';
import { $specificTradeOffersGroup } from '../../store/specific-trade.store';
import { useEffect, useState } from 'react';
import { filterExpiredOffers } from '../../functions/filter-expired-ofers';
import styles from './index.module.sass';
import { WITHOUT_VAT } from '@/shared/constants/price.constants';

export const ContractDetailsTop = ({
  setModalStatus,
}: {
  setModalStatus: (val: { display: boolean; step: 1 | 2 }) => void;
}) => {
  const data = useStore($specificTradeOffersGroup);

  const [offers, setOffers] = useState(data?.offers);
  useEffect(() => {
    const updateOffers = () => {
      setOffers(filterExpiredOffers(data?.offers));
    };

    updateOffers();
    const intervalId = setInterval(updateOffers, 30000);

    return () => clearInterval(intervalId);
  }, [data]);

  const offersIds = offers?.map((item) => item.id);
  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <h4>{data?.buyer?.name}</h4>
        <span className={styles.buyerType}>
          {data?.buyer?.type === 'external' ? 'внешний контрагент' : 'ваш контрагент'}
        </span>
      </div>
      <div className={styles.metrics}>
        <div className={styles.metric}>
          <span className={styles.label}>общий вес культур</span>
          <span className={styles.value}>
            {numberToReadable(
              Number(
                offers?.reduce(
                  (acc, curr) => acc + (+curr?.weight + +curr.weight_gain_tons),
                  0,
                ) || 0,
              ),
              2,
            )}{' '}
            т
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>стоимость всех культур {WITHOUT_VAT}</span>
          <span className={styles.value}>
            {numberToReadable(
              Number(offers?.reduce((acc, curr) => acc + +curr?.price_all, 0) || 0),
            )}{' '}
            ₽
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>стоимость логистики</span>
          <span className={styles.value}>
            {numberToReadable(
              Number(
                offers?.reduce((acc, curr) => acc + +curr?.price_logistic, 0) || 0,
              ),
            )}{' '}
            ₽
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>общая сумма сделки {WITHOUT_VAT}</span>
          <span className={styles.value}>
            {numberToReadable(
              Number(offers?.reduce((acc, curr) => acc + +curr?.price_netto, 0) || 0),
            )}{' '}
            ₽
          </span>
        </div>
      </div>
      <ButtonMain
        label="завершить сделку"
        className={styles.action}
        active={Boolean(offersIds?.[0])}
        onClick={
          () => setModalStatus({ display: true, step: 1 })
          // () =>
          // Modal.warn({
          //   title: 'ВАЖНО',
          //   content: (
          //     <>
          //       После нажатия на кнопку "Завершить сделку", Ваш склад зерновой
          //       культуры, будет опустошен на массу отгружаемой в рамках этой сделки
          //       зернокультуры. <br/>Данная операция является необратимой, если Вы не уверены,
          //       в параметрах осуществляемой отгрузки и в целом в деталях сделки - проcим
          //       заранее еще раз уточнить все необходимые параметры сделки и только после
          //       этого, нажимать кнопку "Завершить сделку".{' '}
          //     </>
          //   ),
          //   onOk: async () => await finishOrdersListFx(offersIds as number[]),
          //   cancelText: 'вернуться',
          //   okText: 'подтверждаю',
          //   okButtonProps: { style: { backgroundColor: '#66B28A' }},
          // })
        }
      />
    </div>
  );
};
